import React, { useEffect, useRef, useState } from 'react';
import './CookieBanner.scss';
import CookieBannerContent from './CookieBannerContent/CookieBannerContent';

const initialState = {
  isEntering: false,
  isExiting: false,
};

/**
 * Renders the cookie banner
 * @param {string} message
 * @param {boolean} disabled
 * @returns {JSX.Element}
 * @constructor
 */
const CookieBanner = ({ message = '', disabled = false }) => {
  const [bannerHidden, setBannerHidden] = useState(true);
  const [{ isEntering, isExiting }, setState] = useState(initialState);
  const wrapper = useRef();

  const CONSENT_KEY = '_OWL_LABS_USER_CONSENT';
  const CONSENT_EXPIRY = 604800017; // TODO: see how long / if this is needed. 1 week for now

  const setConsent = () => {
    const now = new Date();

    const item = {
      value: true,
      expiry: now.getTime() + CONSENT_EXPIRY,
    };

    localStorage.setItem(CONSENT_KEY, JSON.stringify(item));
  };

  const getConsent = (key) => {
    const str = localStorage.getItem(key);

    if (!str) {
      return false;
    }

    const item = JSON.parse(str);
    const now = new Date();

    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key);
      return false;
    }

    return true;
  };

  const clearState = () => {
    setState({ ...initialState });
    setBannerHidden(true);
  };

  useEffect(() => {
    setState({
      isEntering: true,
      isExiting: false,
    });

    const consent = getConsent(CONSENT_KEY);

    if (!consent) {
      setBannerHidden(false);
    }
  }, [isEntering, isExiting]);

  return !bannerHidden && !disabled ? (
    <div
      key={message}
      className={`c-cookie-banner ${isEntering ? 'is-entering' : ''} ${
        isExiting ? 'is-exiting' : ''
      }`}
      ref={wrapper}
    >
      <div className="c-cookie-banner__inner background-color-gray">
        <CookieBannerContent
          setState={setState}
          clearState={clearState}
          message={message}
          setConsent={setConsent}
        />
      </div>
    </div>
  ) : null;
};

export default CookieBanner;
